<script setup lang="ts">
// '/' is host-dependent and therefore never prerendered (see nuxt.config.ts):
// on a custom domain it renders the owner's character page, on mychar.gg the
// landing page.
definePageMeta({
  layout: false
})

const { isCustomDomain, customDomainUsername } = useCustomDomain()
</script>

<template>
  <NuxtLayout
    v-if="isCustomDomain && customDomainUsername"
    name="character"
  >
    <CharacterPageView :username="customDomainUsername" />
  </NuxtLayout>
  <NuxtLayout
    v-else
    name="default"
  >
    <HomeLanding />
  </NuxtLayout>
</template>
